/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect, useRef } from 'react';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Edit,
  Toolbar,
  Sort,
  Search,
  ExcelExport,
  Resize,
  Inject,
} from '@syncfusion/ej2-react-grids';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { useStateContext } from '../contexts/ContextProvider';

export default function EditorForm({ props, orgs, fotas, sms }) {
  const [lprops, setLocalProps] = useState(props);
  const [logData, setLogData] = useState(props.logs || []);
  const [newEvent, setNewEvent] = useState(false);
  const orgFieldSettings = { text: 'title', value: '_id' };
  const fieldSettings = { text: 'text', value: 'value' };
  const smsFieldSettings = { text: 'name', value: 'syntax' };
  const fotaFieldSettings = { text: 'name', value: '_id' };
  const groupFieldSettings = { text: 'name', value: '_id' };
  const toolbarOptions = ['ExcelExport', 'Search'];

  const {
    groups,
    setGroups,
    isMobile,
    zRenderMode,
  } = useStateContext();
  const grid = useRef(null);
  const dropdownData = [
    { text: 'FOTA', value: 'fota' },
    { text: 'Push Notification', value: 'push' },
    { text: 'SMS', value: 'sms' },
    { text: 'Email', value: 'email' },
    { text: 'Device Action', value: 'device' },
  ];
  const clickHandler = (args) => {
    if (grid && args.item.properties.text === 'PDF Export') {
      const properties = {
        fileName: `PDFExport_Associates_${new Date().toISOString()}.pdf`,
        pageOrientation: 'Landscape',
      };
      grid.current.pdfExport(properties);
    } else if (grid && grid.current && args.item.properties.text === 'Excel Export') {
      const properties = {
        fileName: `ExcelExport_CampaignLog_${props.Subject}_${new Date().toISOString()}.xlsx`,
        pageOrientation: 'Landscape',
      };
      grid.current.excelExport(properties);
    }
  };
  const [fota, setFota] = useState(false);
  const [device, setDevice] = useState(false);
  const [organizationid, setOrganizationId] = useState('');
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const { REACT_APP_API_ENDPOINT } = process.env;
  useEffect(() => {
    if (props.logs && props.logs.length > 0) {
      setNewEvent(false);
    } else {
      setNewEvent(true);
    }
  }, []);
  useEffect(() => {
    const dataFetch = async () => {
      if (organizationid && organizationid.length > 0) {
        usr.organizationid = organizationid;
      }
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/campaigngroup?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
        // set state when the data received
      if (mydata && mydata.length > 0) {
        const mygroups = [];
        mydata.forEach((element) => {
          mygroups.push(element);
        });
        setGroups(mygroups);
      } else {
        setGroups([]);
      }
    };
    dataFetch();
  }, [organizationid]);

  return (
    <div>
      <div className="mt-2 mb-2">
        <DropDownListComponent
          className="e-field e-textlabel custom-checkbox-label"
          data-name="organizationid"
          id="organizationid"
          required
          name="organizationid"
          placeholder="Choose Organization"
          floatLabelType="Auto"
          fields={orgFieldSettings}
          dataSource={orgs}
          value={lprops.organizationid}
          change={(e) => {
            setLocalProps({ ...lprops, organizationid: e.value });
            setOrganizationId(e.value);
          }}
        />
      </div>
      <div className="mt-2 mb-2">
        <TextBoxComponent
          defaultValue={lprops.Subject}
          name="Subject"
          id="Subject"
          required
          className="e-field e-input"
          data-name="Subject"
          placeholder="Subject"
          floatLabelType="Auto"
          change={(e) => setLocalProps({
            ...lprops,
            Subject: e.value,
          })}
        />
      </div>
      <div className="mt-2 mb-2">
        <DropDownListComponent
          id="EventType"
          required
          placeholder="Choose Event Type"
          floatLabelType="Auto"
          data-name="EventType"
          name="EventType"
          className="e-field"
          fields={fieldSettings}
          dataSource={dropdownData}
          value={lprops.EventType}
          change={(e) => {
            setLocalProps({
              ...lprops,
              EventType: e.value,
            });
            if (e.value === 'fota') {
              setFota(true);
              setDevice(false);
            } else if (e.value === 'device') {
              setDevice(true);
              setFota(false);
            } else {
              setFota(false);
              setDevice(false);
            }
          }}
        />
      </div>
      <div className="mt-2 mb-2" style={{ display: fota || props.EventType === 'fota' ? 'block' : 'none' }}>
        <DropDownListComponent
          id="FOTAImage"
          name="FOTAImage"
          placeholder="Choose FOTA"
          floatLabelType="Auto"
          data-name="FOTAImage"
          className="e-field"
          enabled={fota}
          fields={fotaFieldSettings}
          dataSource={fotas}
          defaultValue={lprops.FOTAImage}
          change={(e) => {
            setLocalProps((prev) => ({
              ...prev,
              FOTAImage: e.value,
            }));
          }}
        />
      </div>
      <div className="mt-2 mb-2" style={{ display: device || props.EventType === 'device' ? 'block' : 'none' }}>
        <DropDownListComponent
          id="actMessage`"
          enabled
          placeholder="Choose Device Action"
          floatLabelType="Auto"
          data-name="DeviceAction"
          name="actMessage"
          className="e-field"
          fields={smsFieldSettings}
          dataSource={sms}
          value={lprops.Description}
          change={(e) => setLocalProps({
            ...lprops,
            Description: e.value,
          })}
        />
      </div>
      <div className="mt-2 mb-2" style={{ display: !device && !fota && lprops.EventType !== 'device' && lprops.EventType !== 'fota' ? 'block' : 'none' }}>
        <TextBoxComponent
          id="Description"
          placeholder="Email/SMS/Push contents"
          floatLabelType="Auto"
          className="e-field e-input"
          data-name="Description"
          name="Description"
          value={lprops.Description || ''}
          onChange={(e) => setLocalProps({
            ...lprops,
            Description: e.value,
          })}
        />
      </div>
      <div className="mt-2 mb-2">
        <DateTimePickerComponent
          required
          placeholder="Pick Start Time"
          floatLabelType="Auto"
          format="MM/dd/yy hh:mm a"
          id="StartTime"
          name="StartTime"
          data-name="StartTime"
          value={lprops.StartTime}
          change={(e) => setLocalProps({
            ...lprops,
            StartTime: e.value,
          })}
          className="e-field"
        />
      </div>
      <div className="mt-2 mb-2">
        <DateTimePickerComponent
          required
          name="EndTime"
          placeholder="Pick End Time"
          floatLabelType="Auto"
          format="MM/dd/yy hh:mm a"
          id="EndTime"
          data-name="EndTime"
          value={lprops.EndTime}
          change={(e) => setLocalProps({
            ...lprops,
            EndTime: e.value,
          })}
          className="e-field"
        />
      </div>
      <div className="mt-2 mb-2">
        <DropDownListComponent
          id="group"
          popupWidth="300px"
          allowResize
          required
          placeholder="Choose Group"
          floatLabelType="Auto"
          data-name="group"
          className="e-field"
          name="group"
          fields={groupFieldSettings}
          dataSource={groups}
          value={lprops.group}
          change={(e) => setLocalProps({
            ...lprops,
            group: e.value,
          })}
        />
      </div>
      {!newEvent && (
      <GridComponent
        ref={grid}
        id="gridcampaignlogs"
        dataSource={logData}
        allowSorting
        allowResizing
        width="100%"
        enableStickyHeader={!isMobile}
        allowTextWrap
        // load={actionBegin}
        toolbarClick={clickHandler}
        allowExcelExport
        enableAdaptiveUI={isMobile}
        rowRenderingMode={zRenderMode}
        toolbar={toolbarOptions}
        enableAltRow
        enablePersistence
      >
        <ColumnsDirective>
          <ColumnDirective
            field="_id"
            headerText="ID"
            visible={false}
            isPrimaryKey
          />
          <ColumnDirective
            field="deviceName"
            headerText="Name"
          />
          <ColumnDirective
            field="log"
            headerText="Log"
          />
          <ColumnDirective
            field="timestamp"
            headerText="Timestamp"
          />
        </ColumnsDirective>
        <Inject services={[Edit, Toolbar, Sort, Resize, Search, ExcelExport]} />
      </GridComponent>
      )}
    </div>
  );
}
